module.exports = __webpack_public_path__ + "static/media/socialLogo.6625e77a.png";